import { render, staticRenderFns } from "./MWrapperFolderLsport.vue?vue&type=template&id=b804063a&scoped=true"
import script from "./MWrapperFolderLsport.vue?vue&type=script&lang=js"
export * from "./MWrapperFolderLsport.vue?vue&type=script&lang=js"
import style0 from "./MWrapperFolderLsport.vue?vue&type=style&index=0&id=b804063a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b804063a",
  null
  
)

export default component.exports